export default class ChatPager
{
    private $lastPublicId: string = '';
    private $pageSize: number = null;
    private $sorting: string = 'showNewer';
    private $totalRows: number = 0;

    /**
     * Create a new Pager instance.
     */
    public constructor(lastPublicId: string = '', pageSize: number = null, sorting: string = 'showNewer')
    {
        this.setTotalRows(Number.MAX_SAFE_INTEGER);
        this.setPageSize(pageSize);
        this.setLastPublicId(lastPublicId);
        this.setSort(sorting);
    }

    public get lastPublicId(): string
    {
        return this.getLastPublicId();
    }

    public set lastPublicId(value: string)
    {
        this.setLastPublicId(value);
    }

    public get pageSize(): number
    {
        return this.getPageSize();
    }

    public set pageSize(value: number)
    {
        this.setPageSize(value);
    }

    public get sorting(): string
    {
        return this.getSort();
    }

    public get totalRows(): number
    {
        return this.getTotalRows();
    }

    public set totalRows(value: number)
    {
        this.setTotalRows(value);
    }

    public get totalPages(): number
    {
        return this.getTotalPages();
    }

    public setLastPublicId(lastPublicId: string): void
    {
        this.$lastPublicId = lastPublicId;
    }

    public getLastPublicId(): string
    {
        return this.$lastPublicId;
    }

    public setPageSize(size: number): void
    {
        this.$pageSize = size;
    }

    public getPageSize(): number
    {
        return this.$pageSize;
    }

    public setSort(sorting: string,): void
    {
        this.$sorting = sorting;
    }

    public getSort(): string
    {
        return this.$sorting;
    }

    public setTotalRows(rows: number): void
    {
        this.$totalRows = !isNaN(rows) && rows > 0 ? rows : 0;
    }

    public getTotalRows(): number
    {
        return this.$totalRows;
    }

    public getTotalPages(): number
    {
        if (this.getPageSize() > 0)
            return Math.ceil(this.getTotalRows() / this.getPageSize());
        else
            return 0;
    }

    public data(): PagerInfo
    {
        return {
            lastPublicId: this.getLastPublicId(),
            size: this.getPageSize(),
            sort: this.getSort(),
        };
    }
}

export interface PagerInfo
{
    lastPublicId: string;
    size: number;
    sort: string;
}
